import React, { useRef, useEffect } from 'react';

import { Flex } from '@chakra-ui/react';
import { MenuItem, Tooltip } from '@material-ui/core';
import { StyledAvatar } from 'components/avatars';
import { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import styled from 'styled-components';
import { StyledTypography, SearchSelectCSS, StyledBox } from 'styles/common';

import { SEARCH_WIDGET_TYPES } from 'constants/ProjectConstants';
import { CloseIcon2, DeliverableIcon } from 'constants/icons';
import theme from 'constants/theme';

import { Typography13 } from 'uiToolkit/Typography';
import { TextLabel } from 'uiToolkitV1/Typography';

// TODO: use componund components pattern and make it flexible
export function IconOption({ renderChildren, ...props }) {
  const { data } = props;
  return (
    <StyledOption {...props}>
      {renderChildren ? (
        renderChildren(data)
      ) : (
        <StyledTypography display="inline" variant="caption">
          {data.label}
        </StyledTypography>
      )}
    </StyledOption>
  );
}

export function MaterialOption(props) {
  const { data, isSelected } = props;
  // This onClick is the onSelect function passed by the parent
  const { onClick } = props.innerProps;
  return (
    <MenuItem onClick={onClick} selected={isSelected}>
      {/* <StyledTypography display="inline" variant="caption"> */}
      {data.label}
      {/* </StyledTypography> */}
    </MenuItem>
  );
}

export const ValueContainerWithGoal = ({ children, ...props }) =>
  components.ValueContainer && (
    <components.ValueContainer {...props}>
      {!!children && <DeliverableIcon padding="1px 2px 1px 0" color="textPrimary" size="tiny" />}
      {children}
    </components.ValueContainer>
  );

export const SingleValueObjective = (props) => {
  const { data } = props;
  return (
    <components.SingleValue {...props}>
      <StyledTypography display="inline" variant="caption">
        {data.label}
      </StyledTypography>
    </components.SingleValue>
  );
};

export function MultiEmployeePhotoLabel(props) {
  return (
    <components.MultiValueLabel {...props}>
      <StyledBox leftGutter={0.25} flexcontainer alignitems="center">
        <StyledAvatar size="tiniest" src={props.data.image} />
        <Typography13 leftGutter={1}>{props.data.label}</Typography13>
      </StyledBox>
    </components.MultiValueLabel>
  );
}

export function MultiEmployeeOnlyPhotoLabel(props) {
  return (
    <components.MultiValueLabel {...props}>
      <Tooltip title={props.data.label}>
        <StyledBox leftGutter={0.25} flexcontainer alignitems="center">
          <StyledAvatar size="fixed16px" src={props.data.image} />
        </StyledBox>
      </Tooltip>
    </components.MultiValueLabel>
  );
}

export function MultiValueRemove(props) {
  return (
    <components.MultiValueRemove {...props}>
      <CloseIcon2 rightGutter={0.5} leftGutter={0.5} size="fixed12px" color={theme.palette.icons.grey2} clickable />
    </components.MultiValueRemove>
  );
}

const StyledTextLabel = styled(TextLabel)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export function PhotoLabelOptionTiny(props) {
  return (
    <StyledOption {...props}>
      <StyledAvatar size="tiny" src={props.data.image} rightGutter={1} />
      <Tooltip
        title={
          <Flex flexDir="column">
            <TextLabel color="white">{props.data.label}</TextLabel>
            <TextLabel color="white">{props?.data?.email}</TextLabel>
          </Flex>
        }
      >
        <Flex flexDir="column">
          <StyledTypography display="inline" variant="caption">
            {props.data.label?.length > 15 ? <>{`${props.data.label.slice(0, 15)}..`}</> : props.data.label}
          </StyledTypography>
          <StyledTextLabel maxWidth="150px" color="text.g2">
            {props?.data?.email}
          </StyledTextLabel>
        </Flex>
      </Tooltip>
    </StyledOption>
  );
}

function SingleValue({ renderChildren, ...props }) {
  const { data } = props;
  return (
    <components.SingleValue {...props}>
      {renderChildren ? (
        renderChildren(data)
      ) : (
        <StyledTypography display="inline" variant="body2">
          {data.label}
        </StyledTypography>
      )}
    </components.SingleValue>
  );
}

function SearchComponent({
  onChange,
  value,
  className,
  iconOptionType = 'default',
  isMulti = false,
  loadOptions,
  placeholder = 'Search',
  components,
  defaultOptions = true,
  styles: customStyles = {},
  rightJustified = false,
  autoFocus = true,
  filterEmpIds = null,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef && autoFocus) {
      inputRef.current.focus();
    }
  }, [inputRef, autoFocus]);

  components = { SingleValue, Option: IconOption, ...components };
  // const styles = { ...defaultStyles, ...customStyles };
  return (
    // <SearchInputContainer className={className}>
    // </SearchInputContainer>
    <SearchSelect
      // menuIsOpen={true}
      placeholder={placeholder}
      // value={searches}
      loadOptions={(value, callback) => loadOptions(value, callback)}
      ref={inputRef}
      defaultOptions={defaultOptions}
      components={components}
      onChange={onChange}
      classNamePrefix="react-select-custom"
      value={value}
      isMulti={isMulti}
      className={className}
      styles={customStyles}
      rightJustified={rightJustified}
      filterOption={({ value }) => {
        if (filterEmpIds && filterEmpIds?.length !== 0) {
          return filterEmpIds.includes(value);
        }
        return true;
      }}
    />
  );
}

const SearchSelect = styled(AsyncSelect)`
  ${SearchSelectCSS};
  // todo - to avoid wrapping of the optio
  .react-select-custom__menu {
    top: unset;
    width: auto;
    min-width: 220px;
    max-width: 400px;
    .react-select-custom__option {
      white-space: nowrap;
    }
  }
  .react-select-custom__multi-value {
    border-radius: 4px;
    background: ${(props) => props.theme.palette.background.grey};
  }
`;

const StyledOption = styled(components.Option)`
  display: grid !important;
  grid-template-columns: auto 5fr;
  align-items: center;
`;

SearchComponent.defaultProps = {
  tag: {
    tagType: null,
    tagName: null,
  },
  widgetType: SEARCH_WIDGET_TYPES.search,
};

export default SearchComponent;
